import { useQuery } from "@tanstack/react-query";
import AreYouSureModal from "components/modals/AreYouSureModal";
import { Panel } from "components/panels";
import Table from "components/Tables/Table";
import React from "react";

interface Props {
  contactId: number
}

export const ContactAliasesPanel = (props: Props) => {
  const [deleteAlias, setDeleteAlias] = React.useState<number | false>(false);
  const query = useQuery({
    queryKey: ["contactAliases", props.contactId],
    queryFn: async () => window.CoreApi.ContactAlias.ListByContact(props.contactId).then(r => r.data),
  });

  const onContactAliasDelete = (alias: server.dto.ContactAlias) => {
    setDeleteAlias(alias.contactAliasId);
  }

  const data = query.data?.data ?? [];

  return <Panel
    title="Aliases"
    panelClassName="s1_related-feature-panel"
    isLoading={query.isLoading}
    hasData={data.length > 0}
  >
    <Table
      items={data}
      isLoading={false}
      getKey={alias => alias.contactAliasId.toString()}
      onDelete={onContactAliasDelete}
      canDelete={() => true}
      hideHeader
      columns={[
        {
          key: "name",
          header: "",
          render: (alias: server.dto.ContactAlias) => alias.name.fullName
        }
      ]}
    />
    {deleteAlias && <AreYouSureModal
      title={RESX.GeneralLabels.Delete}
      textContent={RESX.GeneralWarnings.DeleteSure}
      onClose={() => { setDeleteAlias(false); }}
      onYes={async () => {
        await window.CoreApi.ContactAlias.Delete({ contactAliasId: deleteAlias });
        setDeleteAlias(false);
        query.refetch();
      }}
      yesButtonLabel={RESX.GeneralLabels.Delete}
      yesButtonColor="red"
    />}
  </Panel>
}